import { supabase } from './supabase';
import { isCapacitorNative } from './platform';

// Public https origin of the web app. Single source for the native API fallback AND for
// links that must open in a real browser (privacy/terms) -- on iOS getOrigin() is
// capacitor://localhost, which openInAppBrowser rejects by design (http(s) only).
export const PUBLIC_WEB_BASE = 'https://sliptrack.vercel.app';
const NATIVE_FALLBACK_BASE = PUBLIC_WEB_BASE;
const RAW_API_BASE = process.env.REACT_APP_API_BASE_URL || '';
export const API_BASE = RAW_API_BASE.replace(/\/+$/, '');

export function apiUrl(path) {
  if (!path.startsWith('/')) {
    throw new Error(`apiUrl expected path starting with "/", got "${path}"`);
  }
  if (API_BASE) return `${API_BASE}${path}`;
  if (isCapacitorNative()) return `${NATIVE_FALLBACK_BASE}${path}`;
  return path;
}

export function apiFetch(path, init) {
  return fetch(apiUrl(path), init);
}

// opts.accessToken pins the token (#1415 PR 3, Codex r2 P1): a caller that has already checked whose session it
// holds sends exactly that token, so an auth change between its check and this call cannot swap the account.
// A pinned null sends no Authorization header; it never falls back to the live session.
export async function authedApiFetch(path, init = {}, opts = {}) {
  const authHeader = {};
  if (Object.prototype.hasOwnProperty.call(opts, 'accessToken')) {
    if (opts.accessToken) authHeader.Authorization = `Bearer ${opts.accessToken}`;
  } else if (supabase) {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (session?.access_token) {
        authHeader.Authorization = `Bearer ${session.access_token}`;
      }
    } catch {
      // getSession() failed — proceed without auth, server handles null user gracefully
    }
  }
  return fetch(apiUrl(path), {
    ...init,
    headers: {
      ...init.headers,
      ...authHeader,
    },
  });
}
